import { createSelector } from 'reselect';
import { RootState } from 'src/store';
import { getSelectedLayer, getDocumentById } from 'src/selectors/layers';
import { DOCUMENT } from 'src/pages/editor/components/layer/layerTypes';
import getSurfaceByPage from './getSurfaceByPage';

/**
 * Name of the surface (e.g. `"Front"`, `"Back"`) the currently selected document is on, or
 * `undefined` when nothing is selected, the selection isn't a document (backgrounds/overlays/
 * rulers have no page), or that page has no matching surface yet.
 *
 * There's no independent "which page is the designer looking at" state in Scene Maker (the canvas
 * always shows one composited render of the whole scene, not a per-page view) — this is derived
 * from whichever document is currently selected, which is the closest available signal for "the
 * customizable area currently being edited."
 */
const getActiveSurfaceName = createSelector([getSelectedLayer, (state: RootState) => state], (selectedLayer, state) => {
    if (!selectedLayer?.id || selectedLayer.type !== DOCUMENT) {
        return undefined;
    }

    const document = getDocumentById(state, selectedLayer.id);
    if (!document?.page) {
        return undefined;
    }

    return getSurfaceByPage(state, document.page)?.name;
});

export default getActiveSurfaceName;
